<div class="sl-modal-overlay" *ngIf="verify.showModal" (click)="verify.cancel()">
  <div class="sl-modal" (click)="$event.stopPropagation()">
    <div class="sl-modal-icon sl-modal-icon-verify"><i class="ri-shield-keyhole-line"></i></div>
    <h3 class="sl-modal-title">{{ 'extensionServiceLoginTitle' | translate }}</h3>
    <p class="sl-modal-text">{{ 'extensionServiceLoginSubtitle' | translate: { serviceName: verify.label } }}</p>
    <form class="sl-modal-form" (ngSubmit)="verify.submit()">
      <input
        type="tel"
        class="sl-modal-input"
        [(ngModel)]="verify.mobileNumber"
        name="verifyMobileNumber"
        placeholder="{{ 'mobileNumber' | translate }}"
        [disabled]="verify.loading"
        (keydown)="verify.handleMobileNumberKeyDown($event)"
      />
      <div class="sl-modal-password-wrap">
        <input
          [type]="verify.showPassword ? 'text' : 'password'"
          class="sl-modal-input"
          [(ngModel)]="verify.password"
          name="verifyPassword"
          placeholder="{{ 'password' | translate }}"
          [disabled]="verify.loading"
        />
        <i
          class="sl-modal-password-eye"
          [ngClass]="verify.showPassword ? 'ri-eye-line' : 'ri-eye-off-line'"
          (click)="verify.showPassword = !verify.showPassword"
        ></i>
      </div>
      <p class="sl-modal-error" *ngIf="verify.error">{{ verify.error }}</p>
      <div class="sl-modal-actions">
        <button type="button" class="sl-modal-btn sl-modal-btn-secondary" (click)="verify.cancel()" [disabled]="verify.loading">{{ 'cancel' | translate }}</button>
        <button type="submit" class="sl-modal-btn sl-modal-btn-primary" [disabled]="verify.loading">
          {{ (verify.loading ? 'pleaseWait' : 'submit') | translate }}
        </button>
      </div>
    </form>
  </div>
</div>
